import {
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
} from '../../../../space.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { keyString2x2ocg778b9mu as keyString } from '../../../../keyValue.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_px8ok5q0jdway2 as get_px,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { renderFiles2vz7gmubfqcvp as renderFiles } from '../../../../files/renderFiles.mjs';
import { label287uhiq3m9m4z as label2 } from '../../../../label2.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  ItemChangeInterface3dt2mjp367emm as ItemChangeInterface,
  LineItemInterface2ct3y0vtnbxod as LineItemInterface,
} from '../../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  ChangeRequestItemWrapperlr7b47p0t9ty as ChangeRequestItemWrapper,
  get_cancelled2lvhzg5ousqkd as get_cancelled,
} from '../data.mjs';
import { get_expandButtonTheme1dpdnzsv2lxs8 as get_expandButtonTheme } from '../../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { expandAction2iatt63opw8h9 as expandAction } from '../../../../expansion.mjs';
import { Action1a4ymn5nx79hk as Action } from '../../../../../../utils/utils.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../../theming/separators.mjs';
import { toggle2o6h9frvgo8sq as toggle } from '../../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function lineItemInterfaceDetails(_this__u8e3s4, lineItem, changeInfo) {
  // Inline function 'com.crowpay.views.components.sectionIndentCol' call
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var indent = Indent_Section_getInstance();
  var tmp2 = indent.agr_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace = indent.bgr_1;
  var tmp = get_unpadded(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  var tmp_0;
  var tmp_1 = null;
  if (!((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null)) {
    tmp_0 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_0 = Companion_getInstance();
  }
  var tmp_2 = view.kbb(tmp_0, indented(view, tmp2, afterSpace));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Space())(view_0.pc(), 0.5);
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_0.hbb(p_1, view_1);
  keyString(view_0, 'Description', lineItem.s91());
  label2(view_0, 'Files', VOID, ($this$label2) => renderFiles($this$label2, new (Constant())(_Constant___init__impl__v45mub(lineItem.t91())), get_rem(10)));
  view.hbb(p_0, view_0);
  view.lbb(tmp_2, view_0);
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function pendingItemChangeDetails(_this__u8e3s4, itemChange, changeInfo) {
  // Inline function 'com.crowpay.views.components.sectionIndentCol' call
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var indent = Indent_Section_getInstance();
  var tmp2 = indent.agr_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace = indent.bgr_1;
  var tmp = get_unpadded(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  var tmp_0;
  var tmp_1 = null;
  if (!((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null)) {
    tmp_0 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_0 = Companion_getInstance();
  }
  var tmp_2 = view.kbb(tmp_0, indented(view, tmp2, afterSpace));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Space())(view_0.pc(), 0.5);
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_0.hbb(p_1, view_1);
  var tmp0_elvis_lhs_2 = itemChange.v94();
  keyString(view_0, 'Updated Description', tmp0_elvis_lhs_2 == null ? 'N/A' : tmp0_elvis_lhs_2);
  view.hbb(p_0, view_0);
  view.lbb(tmp_2, view_0);
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function renderChangeRequestItemDetails(_this__u8e3s4, item) {
  var tmp;
  if (item instanceof ChangeRequestItemWrapper()) {
    tmp = renderChangeRequestItemDetails(_this__u8e3s4, item.ogp_1);
  } else {
    if (isInterface(item, LineItemInterface())) {
      tmp = lineItemInterfaceDetails(_this__u8e3s4, item, item);
    } else {
      if (isInterface(item, ItemChangeInterface())) {
        tmp = pendingItemChangeDetails(_this__u8e3s4, item, item);
      } else {
        throw IllegalArgumentException().a1('Unsupported ChangeRequestType');
      }
    }
  }
  return tmp;
}
function changeRequestItemButton(_this__u8e3s4, item, customAction, cache, tableRow) {
  customAction = customAction === VOID ? null : customAction;
  cache = cache === VOID ? null : cache;
  var tmp;
  if (cache == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.collections.getOrPut' call
    var key = item.f40();
    var value = cache.p3(key);
    var tmp_0;
    if (value == null) {
      var answer = Signal().hak(false);
      cache.s3(key, answer);
      tmp_0 = answer;
    } else {
      tmp_0 = value;
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var expanded = tmp1_elvis_lhs == null ? Signal().hak(false) : tmp1_elvis_lhs;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_px(0));
  if (get_cancelled(item)) {
    sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(2.5));
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
    tableRow(view, expanded);
    Companion_getInstance();
  } else {
    var tmp_1 = view.kbb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(2.5)), get_expandButtonTheme(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Button())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.gba(get_px(0));
    view_0.bb9(get_px(0));
    tableRow(view_0, expanded);
    var tmp_2;
    if (!(customAction == null)) {
      tmp_2 = Action('Toggle Expanded', VOID, changeRequestItemButton$slambda_0(customAction, expanded));
    } else {
      tmp_2 = expandAction(expanded);
    }
    view_0.obg(tmp_2);
    view.hbb(p_0, view_0);
    view.lbb(tmp_1, view_0);
  }
  view.lbb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(expanded)), renderChangeRequestItemDetails(view, item));
  greySeparator(view);
  _this__u8e3s4.hbb(p, view);
}
var changeRequestItemButton$slambdaClass;
function changeRequestItemButton$slambda() {
  if (changeRequestItemButton$slambdaClass === VOID) {
    class $ {
      constructor($customAction, $expanded) {
        this.ehc_1 = $customAction;
        this.fhc_1 = $expanded;
      }
      yah($this$Action, $completion) {
        this.ehc_1.zbe($this$Action);
        toggle(this.fhc_1);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    changeRequestItemButton$slambdaClass = $;
  }
  return changeRequestItemButton$slambdaClass;
}
function changeRequestItemButton$slambda_0($customAction, $expanded) {
  var i = new (changeRequestItemButton$slambda())($customAction, $expanded);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  changeRequestItemButton as changeRequestItemButton3gsegq8wnygxl,
  renderChangeRequestItemDetails as renderChangeRequestItemDetails14bsvrbn30hjl,
};
//endregion

//# sourceMappingURL=renderIndividualDetails.mjs.map
